<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Centrum skenovania">
     Centrum skenovania
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history-s2a-chapter.html#change-history-s2a-chapter_sk" title="Hist&oacute;ria zmien">
     Hist&oacute;ria zmien
    </a>
   </p>
   <div id="divd0e8">
   </div>
   <p class="toc-1-style">
    <a href="overview-s2a-chapter.html#overview-s2a-chapter_sk" title="Prehľad">
     Prehľad
    </a>
   </p>
   <div id="divd0e29">
   </div>
   <p class="toc-1-style">
    <a href="checklist-s2a-chapter.html#checklist-s2a-chapter_sk" title="Kontroln&yacute; zoznam pripravenosti na použitie">
     Kontroln&yacute; zoznam pripravenosti na použitie
    </a>
   </p>
   <div id="divd0e84">
   </div>
   <p class="toc-1-style">
    <a href="configuring-s2a-chapter.html#configuring-s2a-chapter_sk" title="Konfigur&aacute;cia aplik&aacute;cie">
     Konfigur&aacute;cia aplik&aacute;cie
    </a>
   </p>
   <div id="divd0e142">
    <p class="toc-2-style">
     <a href="managing-destinations-ews-s2a-group.html#d0e145" title="Spr&aacute;va cieľov&yacute;ch umiestnen&iacute; pomocou n&aacute;stroja Embedded Web Server">
      Spr&aacute;va cieľov&yacute;ch umiestnen&iacute; pomocou n&aacute;stroja Embedded Web Server
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-destinations-opanel-s2a-group.html#d0e1144" title="Spr&aacute;va cieľov&yacute;ch umiestnen&iacute; pomocou ovl&aacute;dacieho panela tlačiarne">
      Spr&aacute;va cieľov&yacute;ch umiestnen&iacute; pomocou ovl&aacute;dacieho panela tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-other-settings-s2a-group.html#d0e1372" title="Nastavenie predvolieb aplik&aacute;cie">
      Nastavenie predvolieb aplik&aacute;cie
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="scanning-documents-s2a-chapter.html#scanning-documents-s2a-chapter_sk" title="Skenovanie dokumentov">
     Skenovanie dokumentov
    </a>
   </p>
   <div id="divd0e2204">
    <p class="toc-2-style">
     <a href="scanning-documents-s2a-chapter.html#scanning-documents_sk" title="Skenovanie dokumentov">
      Skenovanie dokumentov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-s2a-chapter.html#troubleshooting-s2a-chapter_sk" title="Rie&scaron;enie probl&eacute;mov">
     Rie&scaron;enie probl&eacute;mov
    </a>
   </p>
   <div id="divd0e2239">
    <p class="toc-2-style">
     <a href="application-error-scanning-trb-esf-builtin-moja-topic.html#application-error-scanning-trb-esf-builtin-moja_sk" title="Chyba aplik&aacute;cie">
      Chyba aplik&aacute;cie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-settings-do-not-appear-topic.html#trb-settings-do-not-appear_sk" title="Niektor&eacute; nastavenia sa nezobrazuj&uacute; na str&aacute;nke konfigur&aacute;cie aplik&aacute;cie">
      Niektor&eacute; nastavenia sa nezobrazuj&uacute; na str&aacute;nke konfigur&aacute;cie aplik&aacute;cie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="insufficient-memory-trb-topic.html#insufficient-memory-trb_sk" title="Nedostatok pam&auml;te">
      Nedostatok pam&auml;te
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shortcut-icon-does-not-appear-s2a-trb-topic.html#shortcut-icon-does-not-appear-s2a-trb_sk" title="Ikona odkazu sa nezobrazuje">
      Ikona odkazu sa nezobrazuje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="errors-found-in-imported-file-trb-topic.html#errors-found-in-imported-file-trb_sk" title="Importovan&yacute; s&uacute;bor obsahuje chyby">
      Importovan&yacute; s&uacute;bor obsahuje chyby
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-create-multiple-destinations-trb-topic.html#cannot-create-multiple-destinations-trb_sk" title="Nie je možn&eacute; vytv&aacute;rať viacn&aacute;sobn&eacute; cieľov&eacute; umiestnenia">
      Nie je možn&eacute; vytv&aacute;rať viacn&aacute;sobn&eacute; cieľov&eacute; umiestnenia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-add-destinations-shortcuts-trb-topic.html#cannot-add-destinations-shortcuts-trb_sk" title="Nie je možn&eacute; prid&aacute;vať cieľov&eacute; umiestnenia alebo odkazy">
      Nie je možn&eacute; prid&aacute;vať cieľov&eacute; umiestnenia alebo odkazy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-scan-to-selected-destination-s2a-trb-topic.html#cannot-scan-to-selected-destination-s2a-trb_sk" title="Nie je možn&eacute; skenovať do vybran&eacute;ho cieľov&eacute;ho umiestnenia">
      Nie je možn&eacute; skenovať do vybran&eacute;ho cieľov&eacute;ho umiestnenia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-not-received-s2a-trb-topic.html#email-not-received-s2a-trb_sk" title="E-mail nedorazil">
      E-mail nedorazil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-send-to-fax-destinations-trb-topic.html#cannot-send-to-fax-destinations-trb_sk" title="Nie je možn&eacute; odosielať na cieľov&eacute; umiestnenie faxu">
      Nie je možn&eacute; odosielať na cieľov&eacute; umiestnenie faxu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-use-ldap-attribute-trb-topic.html#cannot-use-ldap-attribute-trb_sk" title="V&nbsp;ceste adresy priečinka nie je možn&eacute; použiť atrib&uacute;t LDAP">
      V&nbsp;ceste adresy priečinka nie je možn&eacute; použiť atrib&uacute;t LDAP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-use-barcode-trb-topic.html#cannot-use-barcode-trb_sk" title="Nepodarilo sa nazvať s&uacute;bory cieľov&yacute;ch umiestnen&iacute; e-mailov pomocou čiarov&eacute;ho k&oacute;du">
      Nepodarilo sa nazvať s&uacute;bory cieľov&yacute;ch umiestnen&iacute; e-mailov pomocou čiarov&eacute;ho k&oacute;du
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-scan-immediately-trb-topic.html#cannot-scan-immediately-trb_sk" title="Nie je možn&eacute; použiť okamžit&eacute; spustenie skenovania">
      Nie je možn&eacute; použiť okamžit&eacute; spustenie skenovania
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cannot-delete-barcode-template-topic.html#cannot-delete-barcode-template_sk" title="Nemožno odstr&aacute;niť &scaron;abl&oacute;nu čiarov&eacute;ho k&oacute;du">
      Nemožno odstr&aacute;niť &scaron;abl&oacute;nu čiarov&eacute;ho k&oacute;du
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faq-s2a-chapter.html#faq-s2a-chapter_sk" title="Najčastej&scaron;ie ot&aacute;zky">
     Najčastej&scaron;ie ot&aacute;zky
    </a>
   </p>
   <div id="divd0e2608">
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices_sk" title="Ozn&aacute;menia">
     Ozn&aacute;menia
    </a>
   </p>
   <div id="divd0e2657">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e2660" title="Pozn&aacute;mky k&nbsp;vydaniu">
      Pozn&aacute;mky k&nbsp;vydaniu
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue